import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import PageSkeleton, { type PageSkeletonVariant } from "./PageSkeleton";

/** Route-level placeholder also covers static pages while their bundle is loading. */
export default function RouteLoadingFallback() {
  const { pathname } = useLocation();
  const variant: PageSkeletonVariant =
    /layout-editor|control-room|\/planning\//.test(pathname)
      ? "editor"
      : /sign-in|contact|profile|license$|referee-availability|athlete-entry/.test(
            pathname,
          )
        ? "form"
        : /analytics|^\/$|^\/licensed\/?$/.test(pathname)
          ? "dashboard"
          : /\/app(?:\/|$)|\/display|\/widget|\/my-meets\/[^/]+$|\/backups\/[^/]+$/.test(
                pathname,
              )
            ? "cards"
            : "grid";
  return (
    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        p: { xs: 2, md: 3 },
        bgcolor: "background.default",
      }}
    >
      <PageSkeleton variant={variant} />
    </Box>
  );
}
